import { useCallback, useMemo, useState } from 'react';
import constate from '../../common/lib/constate';
import VideoService from '../service/VideoService';
import { toast } from 'react-toastify';

function usePreference() {
  const [canDownload, setCanDownload] = useState(true);
  const toggleCanDownload = event => {
    const checked = event.target.checked;
    setCanDownload(checked);
    updatePreferences('canDownload', checked);
  };

  const [canComment, setCanComment] = useState(false);
  const toggleCanComment = event => {
    const checked = event.target.checked;
    setCanComment(checked);
    updatePreferences('canComment', checked);
  };

  const [canSeeAnalytics, setCanSeeAnalytics] = useState(true);
  const toggleCanSeeAnalytics = event => {
    const checked = event.target.checked;
    setCanSeeAnalytics(checked);
    updatePreferences('canViewAnalytics', checked);
  };

  const [canShare, setCanShare] = useState(true);
  const toggleCanShare = event => {
    const checked = event.target.checked;
    setCanShare(checked);
    updatePreferences('canShare', checked);
  };

  const [disableGIF, setDisableGIF] = useState(false);
  const toggleDisableGIF = event => {
    const checked = event.target.checked;
    setDisableGIF(checked);
    updatePreferences('disableGif', checked);
  };

  const [shareVideoPlayerOnly, setShareVideoPlayerOnly] = useState(false);
  const toggleShareVideoPlayerOnly = event => {
    const checked = event.target.checked;
    setShareVideoPlayerOnly(checked);
    updatePreferences('sharePlayerOnly', checked);
  };

  const [showSidebar, setShowSidebar] = useState(false);
  const toggleShowSidebar = event => {
    const checked = event.target.checked;
    setShowSidebar(checked);
    updatePreferences('showSidebar', checked);
  };

  const [stopSharing, setStopSharing] = useState(false);

  const updatePreferences = async (settingKey, settingValue) => {
    try {
      let videoId = window.location.pathname.split('/').pop();
      switch (settingKey) {
        case 'stopSharing':
          await VideoService.updateVideo(videoId, { active: !settingValue });
          break;
        default:
          await VideoService.updateVideo(videoId, { settings: { [settingKey]: settingValue } });
      }
      console.log(`${settingKey} state changed!`);
    } catch (err) {
      console.log('Err:', err);
      toast.error(`Unable to change ${settingKey} state.`);
    }
  };

  return useMemo(
    () => ({
      canDownload,
      setCanDownload,
      toggleCanDownload,
      canComment,
      setCanComment,
      toggleCanComment,
      canSeeAnalytics,
      setCanSeeAnalytics,
      toggleCanSeeAnalytics,
      canShare,
      setCanShare,
      toggleCanShare,
      disableGIF,
      setDisableGIF,
      toggleDisableGIF,
      shareVideoPlayerOnly,
      setShareVideoPlayerOnly,
      toggleShareVideoPlayerOnly,
      showSidebar,
      setShowSidebar,
      toggleShowSidebar,
      stopSharing,
      setStopSharing,
      updatePreferences,
    }),
    [canDownload, canComment, canSeeAnalytics, canShare, disableGIF, shareVideoPlayerOnly, stopSharing, showSidebar]
  );
}

export const usePreferenceContext = constate(usePreference);

const PreferenceContext = {
  Provider: usePreferenceContext.Provider,
};

export default PreferenceContext;
